import { jsx } from 'react/jsx-runtime';
import { createContext, useContext, useState, useEffect } from 'react';
import { useCheckoutContext as useCheckoutContext$1 } from '@zooplus/checkout-state';
import useCheckoutContext from '../tests/StorybookTests/hooks/useCheckoutContext.js';
import { useTracking } from '../hooks/useTracking.js';
import { selectConfig } from '../utils/configUtils.js';
import { getInitialPaymentMethods, getInitialSelectedPayment, trackChangePM } from '../utils/modernizePaymentUtils.js';

const PaymentContext = createContext({
    updateSelectedPayment: () => { },
    deleteSavedCard: () => { },
    setSelectedPayment: () => { },
});
const usePaymentContext = () => useContext(PaymentContext);
const PaymentContextProvider = ({ children, isDataMocked = false, }) => {
    const useLoadCheckoutContext = isDataMocked ? useCheckoutContext : useCheckoutContext$1;
    const checkoutContext = useLoadCheckoutContext('payment-frontend');
    const { paymentState, appConfig } = checkoutContext ?? {};
    const { customerId, sid, currency, customerType, isPaymentCollapsed, deleteSavedCard: deleteSavedCardMutation, updatePreferredPayment, deleteSavedBancontact, } = paymentState ?? {};
    const { shop } = appConfig ?? {};
    const { siteId } = shop ?? {};
    const config = selectConfig(appConfig?.environment)(appConfig?.realm);
    const [selectedPayment, setSelectedPayment] = useState(); // for internal use
    const [checkoutState, setCheckoutState] = useState(getInitialPaymentMethods(paymentState, config.adyen.clientKey));
    const track = useTracking({
        sid,
        siteId,
        currency,
        customerId,
        guest: customerType === 'GUEST_CUSTOMER',
    });
    useEffect(() => {
        track?.('EditPaymentClick');
    }, [isPaymentCollapsed]);
    useEffect(() => {
        const transformedPaymentState = getInitialPaymentMethods(paymentState, config.adyen.clientKey);
        if (!paymentState?.isPaymentLoading) {
            const selectedPM = transformedPaymentState?.paymentMethods &&
                getInitialSelectedPayment(transformedPaymentState?.paymentMethods, transformedPaymentState?.customerType, transformedPaymentState?.preferredPayment?.paymentMethodShortName || '', transformedPaymentState.autoshipmentReadyForOrder);
            setSelectedPayment(selectedPM);
        }
        setCheckoutState(transformedPaymentState);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(paymentState)]);
    const updateSelectedPayment = (data) => {
        updatePreferredPayment?.(data);
        trackChangePM(data, checkoutState?.preferredPayment, track);
    };
    const deleteSavedCard = (cardToDelete) => {
        const { paymentMethod, psp, pspIdentifier } = cardToDelete;
        if (paymentMethod === 'BANCONTACT') {
            if (!pspIdentifier) {
                console.log('Card is missing required PSP identifier for Bancontact');
                return;
            }
            deleteSavedBancontact?.({ bancontactIdentifier: pspIdentifier });
        }
        else {
            if (!psp || !pspIdentifier) {
                console.log('Card is missing required PSP or PSP identifier');
                return;
            }
            deleteSavedCardMutation?.({ psp, pspIdentifier });
        }
    };
    return (jsx(PaymentContext.Provider, { value: {
            appConfig,
            selectedPayment,
            checkoutState,
            updateSelectedPayment,
            deleteSavedCard,
            setSelectedPayment,
        }, children: children }));
};

export { PaymentContext, PaymentContextProvider, PaymentContextProvider as default, usePaymentContext };
//# sourceMappingURL=PaymentContextProvider.js.map
